import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../../components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:flex flex-col justify-between bg-navy text-white p-12">
        <Link to="/"><Logo size={36} dark /></Link>
        <div>
          <h2 className="font-heading text-4xl font-light leading-tight max-w-md">
            Know what your salary is already committed to.
          </h2>
          <p className="text-white/60 mt-4 max-w-sm leading-relaxed">
            See what your money is committed to — before you spend what's left.
          </p>
        </div>
        <p className="text-white/40 text-sm">Private early-access trial · No bank credentials required</p>
      </div>
      <div className="flex flex-col justify-center px-6 py-12 md:px-16">
        <div className="md:hidden mb-8"><Link to="/"><Logo size={34} /></Link></div>
        <div className="max-w-sm w-full">
          <h1 className="font-heading text-3xl font-medium text-ink">{title}</h1>
          {subtitle && <p className="text-slatey mt-2">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-slatey">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
